import XLSX from 'xlsx';

export const downloadJsonAsCsv = function (json) {
    const ws = XLSX.utils.json_to_sheet(json);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "sheet");
    XLSX.writeFile(wb, 'sheet.csv');
};

export const downloadJsonAsXlsx = function (json) {
    const ws = XLSX.utils.json_to_sheet(json);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "sheet");
    XLSX.writeFile(wb, 'sheet.xlsx');
};